import { useApiFetch } from "hooks/useApiFetch";
import { createContext, ReactNode, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

type TaskMapsType = {
    mapUrl: string;
};

export const MapUrlContext = createContext<TaskMapsType>({
    mapUrl: "",
});

export function MapUrlProvider({ children }: { children: ReactNode }) {
    const { apiGet } = useApiFetch();
    const params = useParams();

    const [state, setState] = useState<TaskMapsType>({
        mapUrl: "",
    });

    const buildMapUrl = (data: any) => {
        return `${data.url}&query=Sites%20and%20Landscapes,MHID,${data.mhidNumber}`
    }

    useEffect(() => {
        apiGet({
            path: `MapForIwi/GetMapUrl?siteId=${params.id}`,
            onSuccess: (data) =>
                setState({
                    ...state,
                    mapUrl: buildMapUrl(data),
                }),
        });
    }, []);

    return (
        <MapUrlContext.Provider value={state}>
            {children}
        </MapUrlContext.Provider>
    );
}
